import React from 'react';
import { Box, Divider, Grid, Typography } from '@mui/material';

// A section of the Test form: Request, Result, Test scope, Genes tested, Variants (TGCLOUD-1866,
// Phase 2 rework). A real heading, so a screen reader can move between the sections of a long
// Test, and a test can find one by its name.
export default function SectionHeading({
  title,
  caption,
  first = false,
  action
}) {
  return (
    <Grid size={12}>
      {!first && <Divider sx={{ mb: 1.5 }} />}
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
        <Typography
          component="h3"
          variant="subtitle1"
          sx={{ fontWeight: 700, flex: 1 }}
        >
          {title}
        </Typography>
        {action}
      </Box>
      {caption && (
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'text.secondary' }}
        >
          {caption}
        </Typography>
      )}
    </Grid>
  );
}
